"use client";

import { useSyncExternalStore } from "react";

// True once hydrated on the client (always false on the server, avoiding an
// SSR/CSR mismatch). Use it to gate client-only state.
export function useMounted(): boolean {
  return useSyncExternalStore(
    subscribeNoop,
    () => true,
    () => false,
  );
}

function subscribeNoop(): () => void {
  return (): void => undefined;
}
